import { useQuery } from "@apollo/client";
import { useState, useEffect } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { GET_PRICELISTS } from "@/containers/B2BCustomers/B2BCustomersQueries";

interface StandalonePriceListSelectProps {
  unSelect?: boolean;
  onPriceListChange: (value: number | null) => void;
  value?: number | null;
}

export default function StandalonePriceListSelect({
  unSelect = true,
  onPriceListChange,
  value,
}: StandalonePriceListSelectProps) {
  const { data, loading } = useQuery(GET_PRICELISTS);

  // Select default price list when unSelect is false
  useEffect(() => {
    if (!unSelect && data?.findManyPriceList?.length > 0) {
      const defaultPriceList = data.findManyPriceList.find(
        (priceList: any) => priceList.default === true
      );
      if (defaultPriceList) {
        onPriceListChange(defaultPriceList.id);
      }
    }
  }, [unSelect, data?.findManyPriceList, onPriceListChange]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Select
      value={value ? value.toString() : "none"}
      onValueChange={(value) => {
        onPriceListChange(value === "none" ? null : parseInt(value));
      }}
    >
      <SelectTrigger className="w-full px-2 flex items-center gap-2">
        <div className="flex items-center gap-1">
          <span className="text-sm text-gray-500">Pricelist:</span>
          <SelectValue placeholder="Select price list" />
        </div>
      </SelectTrigger>
      <SelectContent>
        {unSelect && <SelectItem value="none">None</SelectItem>}
        {data?.findManyPriceList.map((priceList: any) => (
          <SelectItem key={priceList.id} value={priceList.id.toString()}>
            {priceList.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
